import angular  from 'angular'
import uiRouter from 'angular-ui-router'

import component from './my-details.component'

let module = angular.module('myDetailsModule', [
  uiRouter
])

.config(($stateProvider) => {
  'ngInject'

  $stateProvider
    .state('profile.myProfile.myDetails', {
      url: '/my-details',
      component: 'myDetailsPage',
      authenticate: true
    })
})

.component('myDetailsPage', component)

.name

export default module



// WEBPACK FOOTER //
// ./src/app/pages/profile/my-profile/my-details/index.js